import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appCodeText]'
})
export class CodeTextDirective {

  @Output() validatorCodeText = new EventEmitter<boolean>();
  private regexCode: RegExp = new RegExp(/(<script|script>|\&|\$)\s*/);

  constructor(private el: ElementRef) { }

  @HostListener('keyup', ['$event'])
  filterInput(event) {
    const current: string = this.el.nativeElement.value;
    if (!this.regexCode.test(current)) {
      this.validatorCodeText.emit(true);
      return true;
    } else if (current === '') {
      this.validatorCodeText.emit(true);
      return true;
    } else {
      this.validatorCodeText.emit(false);
      event.preventDefault();
      return false;
    }
  }

}
